import { render, staticRenderFns } from "./CalendarMobileEventsList.vue?vue&type=template&id=61bc2b6d&scoped=true"
import script from "./CalendarMobileEventsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarMobileEventsList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CalendarMobileEventsList.vue?vue&type=style&index=0&id=61bc2b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc2b6d",
  null
  
)

export default component.exports